export const ADMIN_TIME_ZONE = "Africa/Lagos";

function getDate(value) {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function getParts(value, options) {
  const date = getDate(value);
  if (!date) return null;

  return Object.fromEntries(
    new Intl.DateTimeFormat("en-GB", { timeZone: ADMIN_TIME_ZONE, ...options })
      .formatToParts(date)
      .filter(({ type }) => type !== "literal")
      .map(({ type, value: partValue }) => [type, partValue])
  );
}

export function formatAdminDateTime(value, { includeSeconds = true, fallback = "—" } = {}) {
  const parts = getParts(value, {
    day: "2-digit", month: "2-digit", year: "numeric", hour: "numeric", minute: "2-digit",
    ...(includeSeconds ? { second: "2-digit" } : {}), hour12: true
  });
  if (!parts) return fallback;

  const time = includeSeconds
    ? `${parts.hour}:${parts.minute}:${parts.second}`
    : `${parts.hour}:${parts.minute}`;
  return `${parts.day}/${parts.month}/${parts.year}, ${time} ${parts.dayPeriod.toUpperCase()}`;
}

export function formatAdminTime(value, { includeSeconds = true, fallback = "—" } = {}) {
  const parts = getParts(value, {
    hour: "numeric", minute: "2-digit", ...(includeSeconds ? { second: "2-digit" } : {}), hour12: true
  });
  if (!parts) return fallback;

  const time = includeSeconds
    ? `${parts.hour}:${parts.minute}:${parts.second}`
    : `${parts.hour}:${parts.minute}`;
  return `${time} ${parts.dayPeriod.toUpperCase()}`;
}
